var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpeakerLarge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 70,
    viewBox: "0 0 76 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "go6qv82dna",
    x: 0,
    y: 0,
    width: 75,
    height: 75,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00ebff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3051",
    style: {
      filter: "url(#go6qv82dna)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3050"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 702",
    d: "M786.632-356.807a3.319 3.319 0 0 1 3.631-2.357c3.227.072 6.456 0 9.684.033a2.726 2.726 0 0 0 1.7-.553q6.618-4.722 13.264-9.4a3.07 3.07 0 0 1 4.2.335 3.494 3.494 0 0 1 .81 2.512q-.009 6.505 0 13.01v28.964c0 2.463-.5 3.2-2.748 4.033h-.62a22.94 22.94 0 0 1-2.421-1.3c-4.268-2.983-8.5-6.012-12.766-9a2.11 2.11 0 0 0-1.127-.358c-3.328-.028-6.656-.066-9.982 0a3.322 3.322 0 0 1-3.627-2.356zm31.12 11.82v-20.908a6.458 6.458 0 0 0-.013-.774.9.9 0 0 0-1.449-.731c-.156.09-.3.2-.446.308q-6.508 4.607-13.021 9.207a1.085 1.085 0 0 0-.537 1q.024 11.847 0 23.7a1.082 1.082 0 0 0 .528 1.006c2.686 1.879 5.355 3.779 8.03 5.674 1.769 1.253 3.531 2.516 5.31 3.754.826.575 1.529.215 1.593-.785.015-.231 0-.464 0-.7q.006-10.374.005-20.75zM800.1-356.973h-10.068c-1.039 0-1.227.186-1.228 1.209v21.463c0 1.027.189 1.214 1.222 1.215h9.38c.223 0 .446-.028.693-.045z",
    transform: "translate(-777.632 378.76)",
    style: {
      fill: "#8ff4f6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 703",
    d: "M1102.421-325.515a29.24 29.24 0 0 1-8.2 19.85c-.869.923-1.454 1.065-2.012.514s-.43-1.084.42-1.978a26.372 26.372 0 0 0 7.085-13.691 26.978 26.978 0 0 0-6.747-23.819c-.223-.251-.467-.483-.688-.736a1.059 1.059 0 0 1-.067-1.583 1.026 1.026 0 0 1 1.625.11 59.162 59.162 0 0 1 4.337 5.626 29.116 29.116 0 0 1 4.247 15.707z",
    transform: "translate(-1035.428 359.796)",
    style: {
      fill: "#8ff4f6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 704",
    d: "M1047.215-282.227a18.035 18.035 0 0 1-4.969 12.465 4.473 4.473 0 0 1-.381.384 1.024 1.024 0 0 1-1.467.013 1.024 1.024 0 0 1-.059-1.517c.571-.7 1.205-1.35 1.728-2.081a15.994 15.994 0 0 0-1.29-20.171c-.834-.914-.937-1.452-.378-1.977s1.141-.391 1.955.5a18.034 18.034 0 0 1 4.861 12.384z",
    transform: "translate(-991.641 315.978)",
    style: {
      fill: "#8ff4f6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "o1QoZ9.tif"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3050"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 702",
    d: "M786.632-356.807a3.319 3.319 0 0 1 3.631-2.357c3.227.072 6.456 0 9.684.033a2.726 2.726 0 0 0 1.7-.553q6.618-4.722 13.264-9.4a3.07 3.07 0 0 1 4.2.335 3.494 3.494 0 0 1 .81 2.512q-.009 6.505 0 13.01v28.964c0 2.463-.5 3.2-2.748 4.033h-.62a22.94 22.94 0 0 1-2.421-1.3c-4.268-2.983-8.5-6.012-12.766-9a2.11 2.11 0 0 0-1.127-.358c-3.328-.028-6.656-.066-9.982 0a3.322 3.322 0 0 1-3.627-2.356zm31.12 11.82v-20.908a6.458 6.458 0 0 0-.013-.774.9.9 0 0 0-1.449-.731c-.156.09-.3.2-.446.308q-6.508 4.607-13.021 9.207a1.085 1.085 0 0 0-.537 1q.024 11.847 0 23.7a1.082 1.082 0 0 0 .528 1.006c2.686 1.879 5.355 3.779 8.03 5.674 1.769 1.253 3.531 2.516 5.31 3.754.826.575 1.529.215 1.593-.785.015-.231 0-.464 0-.7q.006-10.374.005-20.75zM800.1-356.973h-10.068c-1.039 0-1.227.186-1.228 1.209v21.463c0 1.027.189 1.214 1.222 1.215h9.38c.223 0 .446-.028.693-.045z",
    transform: "translate(-777.632 378.76)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 703",
    d: "M1102.421-325.515a29.24 29.24 0 0 1-8.2 19.85c-.869.923-1.454 1.065-2.012.514s-.43-1.084.42-1.978a26.372 26.372 0 0 0 7.085-13.691 26.978 26.978 0 0 0-6.747-23.819c-.223-.251-.467-.483-.688-.736a1.059 1.059 0 0 1-.067-1.583 1.026 1.026 0 0 1 1.625.11 59.162 59.162 0 0 1 4.337 5.626 29.116 29.116 0 0 1 4.247 15.707z",
    transform: "translate(-1035.428 359.796)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 704",
    d: "M1047.215-282.227a18.035 18.035 0 0 1-4.969 12.465 4.473 4.473 0 0 1-.381.384 1.024 1.024 0 0 1-1.467.013 1.024 1.024 0 0 1-.059-1.517c.571-.7 1.205-1.35 1.728-2.081a15.994 15.994 0 0 0-1.29-20.171c-.834-.914-.937-1.452-.378-1.977s1.141-.391 1.955.5a18.034 18.034 0 0 1 4.861 12.384z",
    transform: "translate(-991.641 315.978)",
    style: {
      fill: "#fff"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerLarge);
export default __webpack_public_path__ + "static/media/speaker-large.3d864edba35df9d3c29efe187b01f2a1.svg";
export { ForwardRef as ReactComponent };